import { render, staticRenderFns } from "./Scholarship.vue?vue&type=template&id=49817fc6&"
import script from "./Scholarship.vue?vue&type=script&lang=js&"
export * from "./Scholarship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports